import React, { FC } from 'react';
import { iconSize } from '../../../../../constants/icon.constants';
import Icon from '../../../../@shared/icon';
import { TRowItemsProps } from '../../../types/index.types';
import formatText from './formatText';
import SubValueRow from './subValueRow';
import { googleModelSpecificationsCtaClick } from '../../../../../utils/analytics';
import { modelSpecsExpand } from '../../../../../constants/analytics.constants';
import useSitecoreContext from '../../../../../hooks/useSitecoreContext';

const RowItems: FC<TRowItemsProps> = (props) => {
  const { obj, toggleRow, index, colHeadings, expandedRows, colOrdInIndex, searchTerm, isLastRow, showHiddenRightCells } = props;
  const {sitecoreContext} = useSitecoreContext();
  const productLine = sitecoreContext?.analytics?.['productLine'] ? sitecoreContext?.analytics?.['productLine'] : undefined;
  const productSeries = sitecoreContext?.analytics?.['productSeries'] ? sitecoreContext?.analytics?.['productSeries'] : undefined;
  const productModel = sitecoreContext?.analytics?.['productModel'] ? sitecoreContext?.analytics?.['productModel'] : undefined;
  return (
    <>
      <tr
        key={`model-detail-specification-table__spec-${obj.group}`}
        className="model-detail-specification-table__spec-category-row"
        onClick={(): void => {
          if (!expandedRows.includes(index)) {
            googleModelSpecificationsCtaClick(modelSpecsExpand, productLine, productSeries, productModel, obj.group, '');
          }
          toggleRow(index);
        }}
      >
        <td
          className="model-detail-specification-table__left-most-cell model-detail-specification-table__spec-category-row-cell"
          colSpan={colHeadings.length + 1}
        >
          <h3
            className={`
            model-detail-specification-table__spec-category-row__inner-box
            ${
              !isLastRow && !expandedRows.includes(index)
                ? 'model-detail-specification-table__spec-category-row__inner-box--border-visible'
                : ''
            }
        `}
          >
            <Icon
              iconName={expandedRows.includes(index) ? 'action-minus' : 'action-plus'}
              size={iconSize.mbl}
              extraClassName={expandedRows.includes(index) ? 'table-minus-icon' : 'table-plus-icon'}
            />
            {formatText(obj.group, searchTerm)}
          </h3>
        </td>
      </tr>
      {obj.items &&
        obj.items.map((subObj, accIndex, subArr) => (
          // eslint-disable-next-line react/jsx-key
          <SubValueRow
            subObj={subObj}
            subArr={subArr}
            accIndex={accIndex}
            colOrdInIndex={colOrdInIndex}
            hide={!expandedRows.includes(index)}
            showHiddenRightCells={showHiddenRightCells}
            searchTerm={searchTerm}
          />
        ))}
    </>
  );
};

export default React.memo(RowItems);
